import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import {
  getHCCSpecialityMasterCodes,
  fetchHCCSpecialityById,
  editHCCSpeciality,
} from "../../services/hccService";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import FlatPickr from "react-flatpickr";
import crypto from "crypto-js";
import Crypto from "crypto-js";
import moment from "moment";
import "./React-date.css";
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";

const assignedUser = {};
function EditModal({
  isOpen,
  closeModal,
  setInvalidateList,
  id,
  hccDropdownOptions,
  setCurrentPage,
  userDetail,
  hccFields,
  hccFieldsValue,
  customFieldIdsForValidation,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [masterCode, setMasterCode] = useState(null);
  const [dateOfService, setDateOfService] = useState("");
  const [isYearChanged, setIsYearChanged] = useState(false);
  const originalCodeRef = useRef(null);
  const revisedCodeRef = useRef(null);
  const [hccFieldOnChangeData, setHCCFieldOnChangeData] = useState({});
  const [customFieldsError, setCustomFieldsError] = useState({});
  const {
    register,
    handleSubmit,
    control,
    reset,
    getValues,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      reviewDate: moment().format("MM/DD/YYYY"),
      receivedDate: moment().format("MM/DD/YYYY"),
    },
  });

  useEffect(() => {
    if (dateOfService) {
      setValue("originalCode", []);
      setValue("revisedCode", []);
      setValue("originalCodeDescription", "");
      setValue("revisedCodeDescription", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isYearChanged]);

  const fetchHCCSpecialityOriginalCodes = async () => {
    try {
      setIsLoading(true);
      const reqBody = {
        code: originalCodeRef?.current?.state?.text,
        dateOfService: getValues("dateOfService")
          ? moment(getValues("dateOfService"), "MM/DD/YYYY").format(
              "DD-MM-YYYY"
            )
          : null,
      };
      const res = await getHCCSpecialityMasterCodes({ data: reqBody });
      if (res.success) {
        setMasterCode(res?.data);
      }
    } catch (err) {
      console.log(err);
    }
    setIsLoading(false);
  };

  const fetchHCCSpecialityRevisedCodes = async () => {
    try {
      setIsLoading(true);
      const reqBody = {
        code: revisedCodeRef?.current?.state?.text,
        dateOfService: getValues("dateOfService")
          ? moment(getValues("dateOfService"), "MM/DD/YYYY").format(
              "DD-MM-YYYY"
            )
          : null,
      };
      const res = await getHCCSpecialityMasterCodes({ data: reqBody });
      if (res.success) {
        setMasterCode(res?.data);
      }
    } catch (err) {
      console.log(err);
    }
    setIsLoading(false);
  };

  function decryptMember(encrypted) {
    const decrypted = Crypto.AES.decrypt(
      encrypted,
      process.env.REACT_APP_SECRET_PASS
    );
    return decrypted.toString(Crypto.enc.Utf8);
  }

  const getHCCSpecialityById = async (id) => {
    try {
      const res = await fetchHCCSpecialityById(id);
      if (res?.success) {
        reset({
          validate: {
            value: res?.data?.Validate?.id,
            label: res?.data?.Validate?.name,
          },
          originalCode: res?.data?.originalCode
            ? [
                {
                  name: res?.data?.originalCode,
                },
              ]
            : [],
          originalCodeDescription: res?.data?.originalCodeDescription,
          revisedCode: res?.data?.revisedCode
            ? [
                {
                  name: res?.data?.revisedCode,
                },
              ]
            : [],
          v24: res?.data?.v24,
          v28: res?.data?.v28,
          revisedCodeDescription: res?.data?.revisedCodeDescription,
          reasonCode: {
            value: res?.data?.ReasonCode?.id,
            label: res?.data?.ReasonCode?.name,
          },
          source: {
            value: res?.data?.Source?.id,
            label: res?.data?.Source?.name,
          },
          coderName: res?.data?.coderId?.id
            ? {
                value: res?.data?.coderId?.id,
                label: `${res?.data?.coderId?.first_name} ${res?.data?.coderId?.last_name}`,
              }
            : null,
          reviewerNote: res?.data?.reviewerNotes,
          dateOfService: res?.data?.dateOfService
            ? moment(res?.data?.dateOfService).format("MM/DD/YYYY")
            : "",
          receivedDate: res?.data?.receivedDate
            ? moment(res?.data?.receivedDate).format("MM/DD/YYYY")
            : "",
          memberId: res?.data?.memberId
            ? decryptMember(res?.data?.memberId)
            : "",
          memberName: res?.data?.memberName
            ? decryptMember(res?.data?.memberName)
            : "",
          medicareNo: res?.data?.medicareNo
            ? decryptMember(res?.data?.medicareNo)
            : "",
          payor: res?.data?.HCCPayor?.id
            ? {
                value: res?.data?.HCCPayor?.id,
                label: res?.data?.HCCPayor?.name,
              }
            : null,
          dateOfBirth: res?.data?.dateOfBirth
            ? moment(res?.data?.dateOfBirth).format("MM/DD/YYYY")
            : "",
        });
        if (res?.data?.coderId?.id) {
          assignedUser.value = res?.data?.coderId?.id;
          assignedUser.label = `${res?.data?.coderId?.first_name} ${res?.data?.coderId?.last_name}`;
        }
        setDateOfService(
          res?.data?.dateOfService
            ? moment(res?.data?.dateOfService).format("MM/DD/YYYY")
            : ""
        );
        const data = hccFieldsValue?.reduce((acc, item) => {
          if (item?.HCCField?.type === "dropdown") {
            acc[item.HCCFieldId] = item.HCCDropdownOptions
              ? item.HCCField?.isMultiSelect
                ? item.HCCDropdownOptions?.map((dropdown) => ({
                    value: dropdown?.id,
                    label: dropdown?.name,
                  }))
                : {
                    value: item?.HCCDropdownOptions[0]?.id,
                    label: item?.HCCDropdownOptions[0]?.name,
                  }
              : null;
          } else {
            acc[item.HCCFieldId] = item.value;
          }
          return acc;
        }, {});
        setHCCFieldOnChangeData(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getHCCSpecialityById(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async (data) => {
    try {
      const isValid = validateNewCustomFields();
      if (!isValid) return;
      setIsSaving(true);
      const reqBody = {
        memberId: data.memberId
          ? crypto.AES.encrypt(
              data.memberId,
              process.env.REACT_APP_SECRET_PASS
            ).toString()
          : null,
        memberName: data.memberName
          ? crypto.AES.encrypt(
              data.memberName,
              process.env.REACT_APP_SECRET_PASS
            ).toString()
          : null,
        medicareNo: data.medicareNo
          ? crypto.AES.encrypt(
              data.medicareNo,
              process.env.REACT_APP_SECRET_PASS
            ).toString()
          : null,
        originalCodeDescription: data.originalCodeDescription,
        revisedCodeDescription: data.revisedCodeDescription,
        coder: data.coderName?.value,
        v24: data.v24,
        v28: data.v28,
        ValidateId: data.validate?.value,
        SourceId: data.source?.value,
        ReasonCodeId: data.reasonCode?.value,
        originalCode: data.originalCode?.[0]?.name ?? "",
        revisedCode: data.revisedCode?.[0]?.name ?? "",
        reviewDate: data.reviewDate
          ? moment(data.reviewDate).format("DD-MM-YYYY")
          : "",
        reviewerNotes: data.reviewerNote,
        dateOfService: data.dateOfService
          ? moment(data.dateOfService).format("DD-MM-YYYY")
          : "",
        receivedDate: data.receivedDate
          ? moment(data.receivedDate).format("DD-MM-YYYY")
          : "",
        HCCPayorId: data.payor?.value,
        dateOfBirth: data.dateOfBirth
          ? moment(data.dateOfBirth).format("DD-MM-YYYY")
          : null,
      };

      reqBody.hccFields = {};
      Object.entries(hccFieldOnChangeData)?.forEach(([key, value]) => {
        reqBody.hccFields[key] = value;
      });

      const res = await editHCCSpeciality(reqBody, id);
      if (res?.success) {
        setInvalidateList((prev) => !prev);
        setCurrentPage(1);
        window.toastr.success(res?.message);
        closeModal();
      }
    } catch (error) {
      window.toastr.error(
        error?.response?.data?.message ||
          "Something went wrong. Please try again!"
      );
      console.log(error);
    }
    setIsSaving(false);
  };

  const hideModal = () => {
    closeModal();
    reset({
      medicareNo: "",
      coderName: "",
      originalCode: "",
      originalCodeDescription: "",
      v24: "",
      validate: "",
      revisedCode: "",
      revisedCodeDescription: "",
      reasonCode: "",
      source: "",
      v28: "",
      reviewerNote: "",
      reviewDate: "",
      dateOfService: "",
      receivedDate: "",
      memberId: "",
      memberName: "",
      payor: "",
      dateOfBirth: "",
    });
  };

  const renderCodeOptions = () =>
    masterCode?.map((item) => ({
      name: item?.code,
      id: item?.id,
      description: item?.description,
      v24: item?.v24,
      v28: item?.v28,
    }));
  const renderValidateOptions = () =>
    hccDropdownOptions?.validate?.map((item) => ({
      value: item?.id,
      label: item?.name,
    }));
  const rendersourceOptions = () =>
    hccDropdownOptions?.source?.map((item) => ({
      value: item?.id,
      label: item?.name,
    }));
  const renderReasonCodeOptions = () =>
    hccDropdownOptions?.reasonCode?.map((item) => ({
      value: item?.id,
      label: item?.name,
    }));
  const renderPayors = () =>
    hccDropdownOptions?.payors?.map((item) => ({
      value: item?.id,
      label: item?.name,
    }));
  let coderOption = [
    {
      value: userDetail?.id,
      label: `${userDetail?.first_name} ${userDetail?.last_name}`,
    },
  ];
  if (assignedUser.value && assignedUser.value !== userDetail?.id) {
    coderOption = [...coderOption, assignedUser];
  }

  const renderCoders = () => coderOption;

  function validateNewCustomFields() {
    let isValid = true;
    for (const key of customFieldIdsForValidation) {
      if (
        !hccFieldOnChangeData[key] ||
        (Array.isArray(hccFieldOnChangeData[key]) &&
          hccFieldOnChangeData[key].length === 0)
      ) {
        setCustomFieldsError((prev) => ({ ...prev, [key]: "Required" }));
        isValid = false;
      } else {
        setCustomFieldsError((prev) => ({ ...prev, [key]: "" }));
      }
    }

    return isValid;
  }

  const handleHCCFieldDataChange = (fieldId, value) => {
    setHCCFieldOnChangeData((prev) => ({ ...prev, [fieldId]: value }));
  };

  const renderHCCField = (field) => {
    const type = field.type;
    // const hasData = Boolean(hccFieldOnChangeData[field.id]);
    if (type === "text" || type === "number") {
      return (
        <input
          type={type}
          className="form-control"
          value={hccFieldOnChangeData[field.id]}
          onChange={(e) => handleHCCFieldDataChange(field.id, e.target.value)}
          // disabled={hasData}
        />
      );
    } else if (type === "date") {
      return (
        <div className="position-relative">
          <FlatPickr
            className="form-control"
            placeholder="Select a Date"
            options={{
              dateFormat: "m/d/Y",
            }}
            value={hccFieldOnChangeData[field.id]}
            onChange={(_, date) => handleHCCFieldDataChange(field.id, date)}
            // disabled={hasData}
          />
          <button
            type="button"
            style={{
              position: "absolute",
              top: "50%",
              right: 0,
              transform: "translateY(-50%)",
            }}
            className="btn btn-icon"
            onClick={() => handleHCCFieldDataChange(field.id, "")}
            // disabled={hasData}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
      );
    } else if (type === "dropdown") {
      let renderOptions = () =>
        field.HCCDropdownOptions?.map((option) => ({
          label: option?.name,
          value: option?.id,
        }));
      return (
        <Select
          options={renderOptions()}
          isMulti={field?.isMultiSelect || false}
          value={hccFieldOnChangeData[field.id]}
          onChange={(e) => handleHCCFieldDataChange(field.id, e)}
          // isDisabled={hasData}
        />
      );
    }
  };

  return (
    <Modal show={isOpen} onHide={() => hideModal()} centered size="xl">
      <Modal.Header className="pb-2" closeButton>
        <Modal.Title>
          <h2>Edit HCC Record</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="mb-4">
        <form
          id="kt_modal_new_card_form"
          className="form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="row mt-5">
            <div className="col-md-4 fv-row">
              <label
                htmlFor="MedicareNo"
                className="fs-6 fw-semibold form-label mb-2 assign-to"
              >
                Medicare No
              </label>
              <input
                {...register("medicareNo", {
                  // required: { value: true, message: 'Required' },
                  // validate: (value) => {
                  //   if (value?.trim() === '') {
                  //     return 'Required';
                  //   }
                  //   return true;
                  // },
                })}
                type="text"
                className="form-control"
                // disabled={watch("medicareNo")}
              />
              {errors?.medicareNo && (
                <div className="text-danger small">
                  {" "}
                  {errors.medicareNo?.message}{" "}
                </div>
              )}
            </div>

            <div className="col-md-4 fv-row">
              <label
                htmlFor="memberId"
                className="fs-6 fw-semibold form-label mb-2 assign-to"
              >
                Member ID
              </label>
              <input
                {...register("memberId", {})}
                type="text"
                className="form-control"
                // disabled={watch("memberId")}
              />
              {errors?.memberId && (
                <div className="text-danger small">
                  {" "}
                  {errors.memberId?.message}{" "}
                </div>
              )}
            </div>

            <div className="col-md-4 fv-row">
              <label
                htmlFor="memberName"
                className="fs-6 fw-semibold form-label mb-2 assign-to"
              >
                Member Name
              </label>
              <input
                {...register("memberName", {})}
                type="text"
                className="form-control"
                onChange={(e) => {
                  e.target.value = e.target.value.toUpperCase();
                  register("memberName").onChange(e);
                }}
                // disabled={watch("memberName")}
              />
              {errors?.memberName && (
                <div className="text-danger small text-uppercase">
                  {" "}
                  {errors.memberName?.message}{" "}
                </div>
              )}
            </div>

            <div className="col-md-4 fv-row">
              <label
                htmlFor="dateOfBirth"
                className="fs-6 fw-semibold form-label mb-2 assign-to mt-5"
              >
                Date of Birth
              </label>
              <Controller
                name="dateOfBirth"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Datetime
                    timeFormat={false}
                    dateFormat="MM/DD/YYYY"
                    value={value || ""}
                    onChange={onChange}
                    closeOnSelect={true}
                    initialViewDate={moment("01/01/1960", "MM/DD/YYYY").format(
                      "MM/DD/YYYY"
                    )}
                    inputProps={{
                      placeholder: "Pick a Date",   
                      className: "form-control",
                      // disabled: watch("dateOfBirth"),
                    }}
                  />
                )}
              />
              {errors?.dateOfBirth && (
                <div className="text-danger small">
                  {" "}
                  {errors.dateOfBirth?.message}{" "}
                </div>
              )}
            </div>

            {/* recieved date is commented  */}
            {/* <div className="col-md-4 fv-row">

              <label htmlFor="receivedDate" className="fs-6 fw-semibold form-label mb-2 assign-to mt-5">Received Date</label>
              <Controller
                name="receivedDate"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <FlatPickr
                    options={{
                      dateFormat: 'm/d/Y',
                    }}
                    value={value}
                    onChange={(_, currentdateString) => {
                      onChange(currentdateString);
                    }}
                    className="form-control"
                    placeholder="Pick a date"
                  />
                )}
              />
              {errors?.receivedDate
                && <div className="text-danger small"> {errors.receivedDate?.message} </div>}
            </div> */}

            <div className="col-md-4 fv-row mt-5">
              <label
                htmlFor="coderName"
                className="fs-6 fw-semibold form-label mb-2 assign-to"
              >
                Coder Name
              </label>
              <Controller
                name="coderName"
                rules={
                  {
                    // required: { value: true, message: 'Required' },
                  }
                }
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    components={{ IndicatorSeparator: () => null }}
                    options={renderCoders()}
                    isClearable
                    // isDisabled={watch("coderName")}
                  />
                )}
              />
              {errors?.coderName && (
                <div className="text-danger small">
                  {" "}
                  {errors.coderName?.message}{" "}
                </div>
              )}
            </div>

            <div className="col-md-4 fv-row mt-5">
              <label
                htmlFor="payor"
                className="fs-6 fw-semibold form-label mb-2 assign-to"
              >
                Payor
              </label>
              <Controller
                name="payor"
                rules={
                  {
                    // required: { value: true, message: 'Required' },
                  }
                }
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    components={{ IndicatorSeparator: () => null }}
                    isClearable
                    options={renderPayors()}
                    // isDisabled={watch("payor")}
                  />
                )}
              />
              {errors?.payor && (
                <div className="text-danger small">
                  {" "}
                  {errors.payor?.message}{" "}
                </div>
              )}
            </div>

            {hccFields?.map((field) => (
              <div key={field.id} className="col-xl-4 col-lg-4 col-4 mt-5">
                <label
                  className={`form-label ${
                    field?.validation === "Mandatory" ? "required" : ""
                  }`}
                >
                  {field.name}
                </label>
                {renderHCCField(field)}
                {customFieldsError?.[field.id] && (
                  <p className="fs-7 text-danger">
                    {customFieldsError?.[field.id]}
                  </p>
                )}
              </div>
            ))}

            {/* dos */}
            <div className="col-md-12 fv-row mt-5 row">
              <div className="col-md-4 fv-row">
                <label
                  htmlFor="dateOfService"
                  className="fs-6 fw-semibold form-label mb-2 assign-to mt-5"
                >
                  Date of Service
                </label>
                <Controller
                  name="dateOfService"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Datetime
                      timeFormat={false}
                      dateFormat="MM/DD/YYYY"
                      inputProps={{
                        placeholder: "Pick a Date",
                        className: "form-control",
                        value: value ? moment(value).format("MM/DD/YYYY") : "",
                      }}
                      value={value ? moment(value, "MM/DD/YYYY") : ""}
                      onChange={(selectedDate) => {
                        if (
                          !moment.isMoment(selectedDate) ||
                          !selectedDate.isValid()
                        )
                          return;
                        const lastYear = moment(
                          dateOfService,
                          "MM/DD/YYYY"
                        ).year();
                        const selectedYear = selectedDate.year();

                        if (selectedYear !== lastYear) {
                          setIsYearChanged((prev) => !prev);
                        }
                        onChange(selectedDate);
                        setDateOfService(selectedDate.format("MM/DD/YYYY"));
                      }}
                      closeOnSelect={true}
                    />
                  )}
                />
                {errors?.dateOfService && (
                  <div className="text-danger small">
                    {" "}
                    {errors.dateOfService?.message}{" "}
                  </div>
                )}
              </div>
              <div className="col-md-4 fv-row mt-5">
                <label
                  htmlFor="validate"
                  className="fs-6 fw-semibold form-label mb-2 assign-to"
                >
                  Validate
                </label>
                <Controller
                  name="validate"
                  rules={
                    {
                      // required: { value: true, message: 'Required' },
                    }
                  }
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      components={{ IndicatorSeparator: () => null }}
                      options={renderValidateOptions()}
                    />
                  )}
                />
                {errors?.validate && (
                  <div className="text-danger small">
                    {" "}
                    {errors.validate?.message}{" "}
                  </div>
                )}
              </div>
              <div className="col-md-4 fv-row mt-5">
                <label
                  htmlFor="reasonCode"
                  className="fs-6 fw-semibold form-label mb-2 assign-to"
                >
                  Reason Code
                </label>
                <Controller
                  name="reasonCode"
                  rules={
                    {
                      // required: { value: true, message: 'Required' },
                    }
                  }
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      components={{ IndicatorSeparator: () => null }}
                      options={renderReasonCodeOptions()}
                    />
                  )}
                />
                {errors?.reasonCode && (
                  <div className="text-danger small">
                    {" "}
                    {errors.reasonCode?.message}{" "}
                  </div>
                )}
              </div>
            </div>

            {/* v24 icd codes  */}
            <div className="col-md-12 fv-row mt-5 row">
              <div className="col-md-4 fv-row mt-5">
                <label
                  htmlFor="originalCode"
                  className="fs-6 fw-semibold form-label mb-2 assign-to"
                >
                  V24 ICD Code
                </label>
                <Controller
                  name="originalCode"
                  rules={
                    {
                      // required: { value: true, message: 'Required' },
                    }
                  }
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <AsyncTypeahead
                      filterBy={() => true}
                      isLoading={isLoading}
                      selected={value}
                      id="originalCode"
                      placeholder="..."
                      labelKey={(option) => option?.name}
                      ignoreDiacritics={true}
                      options={renderCodeOptions()}
                      useCache={false}
                      debounceTime={800}
                      minLength={2}
                      onSearch={fetchHCCSpecialityOriginalCodes}
                      ref={originalCodeRef}
                      onChange={(val) => {
                        onChange(val);
                        setValue(
                          "originalCodeDescription",
                          val?.[0]?.description
                        );
                        setValue("v24", val?.[0]?.v24);
                        if (getValues("revisedCode")?.length === 0) {
                          setValue("v28", val?.[0]?.v28);
                        }
                      }}
                      disabled={!watch("dateOfService")}
                    />
                  )}
                />
                {errors?.originalCode && (
                  <div className="text-danger small">
                    {" "}
                    {errors.originalCode?.message}{" "}
                  </div>
                )}
              </div>

              <div className="col-md-4 mt-5 fv-row">
                <label
                  htmlFor="originalCodeDescription"
                  className="fs-6 fw-semibold form-label mb-2 assign-to"
                >
                  V24 ICD Code Description
                </label>
                <textarea
                  {...register("originalCodeDescription", {
                    // required: { value: true, message: 'Required' },
                  })}
                  id="originalCodeDescription"
                  type="text"
                  className="form-control"
                />
                {errors?.originalCodeDescription && (
                  <div className="text-danger small">
                    {" "}
                    {errors.originalCodeDescription?.message}{" "}
                  </div>
                )}
              </div>

              <div className="col-md-4 mt-5 fv-row ">
                <label
                  htmlFor="v24"
                  className="fs-6 fw-semibold form-label mb-2 assign-to"
                >
                  V24 HCC Value
                </label>
                <input
                  {...register("v24", {
                    // required: { value: true, message: 'Required' },
                  })}
                  id="v24"
                  type="text"
                  className="form-control"
                  readOnly
                />
                {errors?.v24 && (
                  <div className="text-danger small">
                    {" "}
                    {errors.v24?.message}{" "}
                  </div>
                )}
              </div>
            </div>

            {/* v28 icd codes  */}
            <div className="col-md-12 fv-row mt-5 row">
              <div className="col-md-4 fv-row mt-5">
                <label
                  htmlFor="revisedCode"
                  className="fs-6 fw-semibold form-label mb-2 assign-to"
                >
                  V28 ICD Code
                </label>
                <Controller
                  name="revisedCode"
                  rules={
                    {
                      // required: { value: true, message: 'Required' },
                    }
                  }
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <AsyncTypeahead
                      filterBy={() => true}
                      isLoading={isLoading}
                      id="revisedCode"
                      placeholder="..."
                      selected={value}
                      labelKey={(option) => option?.name}
                      ignoreDiacritics={true}
                      options={renderCodeOptions()}
                      useCache={false}
                      debounceTime={800}
                      minLength={2}
                      onSearch={fetchHCCSpecialityRevisedCodes}
                      ref={revisedCodeRef}
                      onChange={(val) => {
                        onChange(val);
                        setValue(
                          "revisedCodeDescription",
                          val?.[0]?.description
                        );
                        setValue("v28", val?.[0]?.v28);
                      }}
                      disabled={!watch("dateOfService")}
                    />
                  )}
                />
                {errors?.revisedCode && (
                  <div className="text-danger small">
                    {" "}
                    {errors.revisedCode?.message}{" "}
                  </div>
                )}
              </div>

              <div className="col-md-4 fv-row mt-5">
                <label
                  htmlFor="revisedCodeDescription"
                  className="fs-6 fw-semibold form-label mb-2 assign-to"
                >
                  V28 ICD Code Description
                </label>
                <textarea
                  {...register("revisedCodeDescription", {
                    // required: { value: true, message: 'Required' },
                  })}
                  className="form-control"
                />
                {errors?.revisedCodeDescription && (
                  <div className="text-danger small">
                    {" "}
                    {errors.revisedCodeDescription?.message}{" "}
                  </div>
                )}
              </div>

              <div className="col-md-4 fv-row mt-5">
                <label
                  htmlFor="v28"
                  className="fs-6 fw-semibold form-label mb-2 assign-to"
                >
                  V28 HCC Value
                </label>
                <input
                  {...register("v28", {
                    // required: { value: true, message: 'Required' },
                  })}
                  id="v28"
                  type="text"
                  className="form-control"
                  readOnly
                />
                {errors?.v28 && (
                  <div className="text-danger small">
                    {" "}
                    {errors.v28?.message}{" "}
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-4 fv-row mt-5">
              <label
                htmlFor="source"
                className="fs-6 fw-semibold form-label mb-2 assign-to"
              >
                Source
              </label>
              <Controller
                name="source"
                rules={
                  {
                    // required: { value: true, message: 'Required' },
                  }
                }
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    components={{ IndicatorSeparator: () => null }}
                    options={rendersourceOptions()}
                  />
                )}
              />
              {errors?.source && (
                <div className="text-danger small">
                  {" "}
                  {errors.source?.message}{" "}
                </div>
              )}
            </div>
            <div className="col-md-4 fv-row mt-5">
              <label
                htmlFor="reviewDate"
                className="fs-6 fw-semibold form-label mb-2 assign-to"
              >
                Review Date
              </label>
              <Controller
                name="reviewDate"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <FlatPickr
                    options={{
                      dateFormat: "m/d/Y",
                    }}
                    value={value}
                    onChange={(_, currentdateString) => {
                      onChange(currentdateString);
                    }}
                    className="form-control"
                    placeholder="Pick a date"
                  />
                )}
              />
              {errors?.reviewDate && (
                <div className="text-danger small">
                  {" "}
                  {errors.reviewDate?.message}{" "}
                </div>
              )}
            </div>
            <div className="col-md-4 fv-row mt-5">
              <label
                htmlFor="reviewerNote"
                className="fs-6 fw-semibold form-label mb-2 assign-to"
              >
                Reviewer Note
              </label>
              <textarea
                {...register("reviewerNote", {
                  // required: { value: true, message: 'Required' },
                })}
                className="form-control"
              />
              {errors?.reviewerNote && (
                <div className="text-danger small">
                  {" "}
                  {errors.reviewerNote?.message}{" "}
                </div>
              )}
            </div>
          </div>

          <div className="d-flex pt-5 mt-5 justify-content-center">
            <button
              onClick={closeModal}
              type="button"
              id="cancel-button"
              className="btn btn-sm btn-light"
            >
              Cancel
            </button>
            <button
              type="submit"
              id="save-button"
              className="btn btn-sm btn-primary ms-3"
            >
              {!isSaving ? (
                <span className="indicator-label">Save</span>
              ) : (
                <span>
                  <span className="spinner-border spinner-border-sm align-middle ms-2" />
                </span>
              )}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default EditModal;
